import { useEffect, useState } from "react";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { isIOSSafari } from "../utils/isIOSSafari";
export const useShouldLoadAdjust = () => {
    const { application: { id }, } = useEnvironment();
    const [shouldLoad, setShouldLoad] = useState(false);
    useEffect(() => {
        /**
         * The banner must not be displayed on the Classified Details Page (CDP) for users on iOS mobile Safari to avoid conflicts with App Clips.
         */
        if (id === "app_cldp" && isIOSSafari()) {
            setShouldLoad(false);
            return;
        }
        setShouldLoad(true);
    }, [id]);
    return shouldLoad;
};
